<template>
    <button class="btn btn-primary btn-rounded-circle" :class="'btn-' + size + ' ' + classes">
        <slot v-if="title === null" />
        <template v-else>
            {{ title }}
        </template>
    </button>
</template>

<script lang="ts">
export default {
    props: {
        title: {
            type: String,
            default: null,
            required: true,
        },
        size: {
            type: String,
            default: '',
        },
        classes: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
.btn {
    &--lg {
        width: 100%;
        padding: 0.5rem 1.5rem;
    }

    &--md {
        padding: 0.25rem 1.5rem;
    }

    &--sm {
        padding: 0.25rem 0.5rem;
    }
}
</style>
